<template>
  <section class="h_72">
    <m-img src="@/v2/mobile/assets/image/h_72.jpg"></m-img>
  </section>
</template>

<script>
export default {}
</script>
